interface GearWithCircuitsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearWithCircuitsSVG = ({ color, style }: GearWithCircuitsSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="49"
    viewBox="0 0 50 49"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12358)">
      <path
        d="M41.523 3.51069C41.523 1.85518 40.1851 0.511841 38.5363 0.511841C36.8875 0.511841 35.5496 1.85518 35.5496 3.51069C35.5496 5.1662 36.8875 6.50954 38.5363 6.50954C40.1851 6.50954 41.523 5.1662 41.523 3.51069Z"
        stroke={color}
        strokeWidth="1.01305"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3811 3.51062H35.5497"
        stroke={color}
        strokeWidth="1.01305"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4175 0.511841V3.90218C17.6066 4.44719 14.992 5.54745 12.7036 7.10317L10.3234 4.7133L4.69151 10.3681L7.07169 12.758C5.52483 15.0558 4.42903 17.681 3.88623 20.5033H0.509644V28.4994H3.88623C4.42903 31.3217 5.52483 33.947 7.07169 36.2447L4.69151 38.6346L10.3234 44.2894L12.7036 41.8996C14.992 43.4527 17.6066 44.5556 20.4175 45.1006V48.4909H28.3811V0.511841H20.4175Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3811 13.2032C27.1349 12.7605 25.7996 12.5046 24.4005 12.5046C17.8028 12.5046 12.4538 17.8754 12.4538 24.5C12.4538 31.1246 17.8028 36.4954 24.4005 36.4954C25.7996 36.4954 27.1349 36.2421 28.3811 35.7995"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.4903 24.5001C48.4903 26.1556 47.1524 27.4989 45.5036 27.4989C43.8548 27.4989 42.5169 26.1556 42.5169 24.5001C42.5169 22.8446 43.8548 21.5012 45.5036 21.5012C47.1524 21.5012 48.4903 22.8446 48.4903 24.5001Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.4903 36.4929C48.4903 38.1484 47.1524 39.4917 45.5036 39.4917C43.8548 39.4917 42.5169 38.1484 42.5169 36.4929C42.5169 34.8374 43.8548 33.494 45.5036 33.494C47.1524 33.494 48.4903 34.8374 48.4903 36.4929Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.523 45.4895C41.523 47.145 40.1851 48.4883 38.5363 48.4883C36.8875 48.4883 35.5496 47.145 35.5496 45.4895C35.5496 43.8339 36.8875 42.4906 38.5363 42.4906C40.1851 42.4906 41.523 43.8339 41.523 45.4895Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.5169 24.5H28.3811"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.4903 12.5072C48.4903 10.8516 47.1524 9.5083 45.5036 9.5083C43.8548 9.5083 42.5169 10.8516 42.5169 12.5072C42.5169 14.1627 43.8548 15.506 45.5036 15.506C47.1524 15.506 48.4903 14.1627 48.4903 12.5072Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3811 45.4894H35.5497"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3811 17.5044H39.5302L43.2202 14.4186"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.2202 34.584L39.5302 31.4982H28.3811"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12358">
        <rect width="50" height="49" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearWithCircuitsSVG;
